var _defs, _use;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgResources = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "resurces-all-categories-a",
    d: "M10,8 L14,8 L14,6 L10,6 L10,8 Z M14,4 C15.1045695,4 16,4.8954305 16,6 L16,8 L18,8 C19.1045695,8 20,8.8954305 20,10 L20,17 C20,18.1045695 19.1045695,19 18,19 L6,19 C4.8954305,19 4,18.1045695 4,17 L4,10 C4,8.8954305 4.8954305,8 6,8 L8,8 L8,6 C8,4.8954305 8.8954305,4 10,4 L14,4 Z M18,10 L6,10 L6,17 L18,17 L18,10 Z",
    fill: "#767676",
    fillOpacity: 1
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fillRule: "evenodd",
    xlinkHref: "#resurces-all-categories-a"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgResources);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/resources.938dcf0a79b37243c34d8aa3bf3cac5e.svg";